import * as React from 'react'
import { createRoot } from 'react-dom/client'

import FallbackPage from 'src/app/router/routes/fallback/fallback-page'

const root = document.getElementById('fallback-root')
if (!root) throw new Error('No root element found')

createRoot(root).render(
  <React.StrictMode>
    <FallbackPage />
  </React.StrictMode>,
)
